import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { OrderListParams } from '../api/orders-api';
import { ORDER_FILTER_FIELDS, ORDER_SORTS } from '../components/order-filters';

/** URL search params of the orders list; mirrors GET /admin/v1/stores/{storeId}/orders. */
export const orderListSearchSchema = indexSearchSchema(ORDER_FILTER_FIELDS, { sort: ORDER_SORTS });

export type OrderListSearch = z.infer<typeof orderListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function orderListParams(search: OrderListSearch): OrderListParams {
  return listParams(search, ORDER_FILTER_FIELDS);
}
